// extracted by mini-css-extract-plugin
export default {"page":"AppSettings_page__s8hOp"};